import { render } from "./MomentBox.vue?vue&type=template&id=3532aec5&scoped=true"
import script from "./MomentBox.vue?vue&type=script&lang=ts"
export * from "./MomentBox.vue?vue&type=script&lang=ts"

import "./MomentBox.vue?vue&type=style&index=0&id=3532aec5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3532aec5"

export default script